import { SearchOutlined } from '@ant-design/icons';
import { Checkbox, Flex, Input } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

export const ServiceCategoriesFilter: ContentType = ({ open, onClose, id }) => {
  const [localSearch, setLocalSearch] = useState<string>('');
  const [localSelectedCategories, setLocalSelectedCategories] = useState<
    number[]
  >([]);

  const { servicesCategoriesOptions, onChangeCategories, filtersMap } =
    useNewClientsListContext();

  const { categories } = filtersMap.get(id)!;

  const onConfirm = useCallback(() => {
    onChangeCategories(localSelectedCategories, id);

    onClose?.();
  }, [localSelectedCategories, onChangeCategories, onClose, id]);

  useEffect(() => {
    if (open) {
      setLocalSelectedCategories(categories);
      setLocalSearch('');
    } else {
      setLocalSelectedCategories([]);
      setLocalSearch('');
      setLocalSearch('');
    }
  }, [categories, open]);

  const filteredTagsOptions = useMemo(() => {
    if (!localSearch) {
      return servicesCategoriesOptions;
    }

    return servicesCategoriesOptions.filter((tagOption) =>
      tagOption?.title
        ?.toString()
        ?.toLowerCase()
        ?.includes(localSearch?.toLowerCase())
    );
  }, [localSearch, servicesCategoriesOptions]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Flex vertical gap={8}>
        <Input
          placeholder="Поиск по категориям услуг"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          prefix={<SearchOutlined />}
        />

        <div className={`${PF}__tags-container`}>
          <div className={`${PF}__tags-list`}>
            <Checkbox.Group
              value={localSelectedCategories}
              options={filteredTagsOptions}
              onChange={(checkedValues) =>
                setLocalSelectedCategories(checkedValues)
              }
              className={`${PF}__checkbox-group`}
            />
          </div>
        </div>
      </Flex>
    </FilterWrapper>
  );
};
